<template>
  <company-mobile-taken-list
    :loading="loading"
    :groups="groups"
    :title="$t('taken')"
    :search="search"
    :show-taken="canCheckReport"
  ></company-mobile-taken-list>
</template>

<script>
import CompanyReportTabTaken from "@/components/company/reports/companyTabs/CompanyReportTabTaken.vue";
import { SHIFTS } from "@/constants/shifts";
import hasBarShifts from "@/components/report/shared/hasBarShifts";
import hasShiftSubtitle from "@/components/report/shared/hasShiftSubtitle";
import { percentOf } from "@/components/report/shared/takenMath";
import CompanyMobileTakenList from "../CompanyMobileTakenList.vue";
import { hasPeriodRefetch } from "../../hasPeriodRefetch";

/**
 * Mobilni "Preuzeto" firme: po firmi obroci sa brojem preuzetih / poručenih i po smeni (firma koja ne sme da
 * vidi preuzimanje dobija samo poručene količine). Smene, firme i period su u zaglavlju. Nasleđuje učitavanje,
 * štampu i Excel iz starog taba.
 */
export default {
  name: "CompanyMobileTaken",
  extends: CompanyReportTabTaken,
  mixins: [hasBarShifts, hasShiftSubtitle, hasPeriodRefetch("fetchMeals")],
  components: { CompanyMobileTakenList },
  computed: {
    groups() {
      const search = this.search;
      return this.filteredCompanies
        .map((company, index) => {
          const found = search ? this.customSearch(company.meals, [{ value: "name" }], search) : company.meals;
          const meals = found
            .filter((meal) => meal.total > 0)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((meal, mealIndex) => ({
              key: `${index}-${meal.id || meal.name}-${mealIndex}`,
              name: meal.name,
              total: meal.total,
              taken: meal.total_payed || 0,
              complete: meal.total > 0 && meal.total_payed >= meal.total,
              shifts: SHIFTS.map((shift) => ({
                id: shift.id,
                orders: meal[`shift${shift.id}`]?.quantity || 0,
                taken: meal[`shift${shift.id}`]?.quantity_payed || 0,
              })).filter((shift) => shift.orders > 0),
            }));
          const ordered = meals.reduce((sum, meal) => sum + meal.total, 0);
          const taken = meals.reduce((sum, meal) => sum + meal.taken, 0);
          return {
            key: `${index}-${company.name}`,
            name: this.toLatin(company.name),
            ordered,
            taken,
            complete: ordered > 0 && taken >= ordered,
            percent: percentOf(taken, ordered),
            meals,
          };
        })
        .filter((group) => group.meals.length);
    },
  },
};
</script>
